
import axios from "axios";
import type { AxiosRequestConfig } from "axios";
// import { encode } from "base-64";
import { readCookie } from "../../utils/helper";
import { isAbortError, reportApiError } from "../../utils/errorPopupBridge";

declare module "axios" {
  interface AxiosRequestConfig {
    /** Skips the global error popup — for fire-and-forget calls. */
    silentError?: boolean;
  }
}

const DEFAULT_API_TIMEOUT_MS = 120_000;

export type ApiRequestConfig = AxiosRequestConfig & {
  skipErrorPopup?: boolean;
};

const instance = axios.create({
  timeout: DEFAULT_API_TIMEOUT_MS,
});

instance.interceptors.request.use((config: any) => {
  if (!config?.headers) throw new Error(`Expected 'config.headers' not to be undefined`);

  // let correlationAppContext = [
  //   {
  //     ApplicationName: "",
  //     CNameOrAzureAppName: window.location.href,
  //     TimeStamp: new Date().toISOString(),
  //   },
  // ];
  const accessToken = "";
  // config.headers["correlation-app-context"] = encode(JSON.stringify(correlationAppContext));
  config.headers["Content-Type"] = "application/json";

  if (readCookie("visitorGuid") != null) {
    config.headers["visitor-id"] = readCookie("visitorGuid");
  }
  if (readCookie("visitGuid") != null) {
    config.headers["visit-id"] = readCookie("visitGuid");
  }
  config.headers["Content-Type"] = "application/json";
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  return config;
});

instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const skipErrorPopup = (error.config as ApiRequestConfig | undefined)?.skipErrorPopup;
    if (!isAbortError(error) && !skipErrorPopup && !error?.config?.silentError) {
      reportApiError(error);
    }
    return Promise.reject(error);
  },
);

export const apiService = {
  get: async <T>(
    url: string,
    params?: any,
    headers?: any,
    config: ApiRequestConfig = {},
  ): Promise<T> => {
    if (!url) throw new Error("Endpoint is required");
    const axiosConfig: ApiRequestConfig = { ...config, params, headers };
    return instance.get(url, axiosConfig) as Promise<T>;
  },

  post: async <T>(
    url: string,
    data: any,
    headers?: any,
    options?: { silentError?: boolean },
  ): Promise<T> => {
    if (!url || !data) throw new Error("Endpoint and data are required");
    return instance.post(url, data, { headers, ...options }) as Promise<T>;
  },

  put: async <T>(url: string, data: any, headers?: any): Promise<T> => {
    if (!url || !data) throw new Error("Endpoint and data are required");
    return instance.put(url, data, { headers }) as Promise<T>;
  },

  patch: async <T>(url: string, data?: any, headers?: any): Promise<T> => {
    if (!url) throw new Error("Endpoint is required");
    return instance.patch(url, data, { headers }) as Promise<T>;
  },
};
